import { gql, useMutation } from '@apollo/client';
import { ServiceTicket } from './useServiceTicketsQuery';

const SERVICE_TICKET_RESOLVE = gql`
  mutation ServiceTicketResolve($id: ID!, $snippetId: ID, $message: String, $notify: Boolean) {
    serviceTicketResolve(id: $id, snippetId: $snippetId, message: $message, notify: $notify) {
      id
      status
      resolvedAt
      resolvedSnippetId
      customerMessage
      customerNotifiedAt
      updatedAt
    }
  }
`;

export interface ServiceTicketResolveVariables {
  id: string;
  snippetId?: string | null;
  message?: string | null;
  notify?: boolean;
}

export interface ServiceTicketResolveData {
  serviceTicketResolve: Pick<
    ServiceTicket,
    'id' | 'status' | 'resolvedAt' | 'resolvedSnippetId' | 'customerMessage' | 'customerNotifiedAt' | 'updatedAt'
  >;
}

export function useServiceTicketResolveMutation() {
  return useMutation<ServiceTicketResolveData, ServiceTicketResolveVariables>(SERVICE_TICKET_RESOLVE);
}
